import React, { useEffect } from "react";
import Modal from "components/foundation/Modal/Modal";
import useBeforeUnload from "features/common/hooks/useBeforeUnload";

interface BeforeUnloadModalProps {
  isDirty: boolean;
  disable?: boolean;
  onConfirm?: ((e: React.MouseEvent<HTMLButtonElement>) => void) | boolean;
  confirmValue?: string;
}

const BeforeUnloadModal = ({
  isDirty,
  disable,
  onConfirm,
  confirmValue,
}: BeforeUnloadModalProps) => {
  /* 화면 전환 로직 */
  const {
    blocking,
    process,
    isBlock,
    enableUnloadTracking,
    disableUnloadTracking,
  } = useBeforeUnload({
    isInitialTracking: false,
  });

  useEffect(() => {
    if (isDirty) {
      enableUnloadTracking();
    }
  }, [enableUnloadTracking, isDirty]);

  useEffect(() => {
    if (disable) {
      disableUnloadTracking();
    }
  }, [disable, disableUnloadTracking]);

  return (
    <Modal.Root open={isBlock}>
      <Modal.Body
        style={{ maxWidth: "39rem" }}
        title={
          <>
            화면 이동 시 변경된 내용은 <br />
            저장되지 않습니다. 이동하시겠습니까?
          </>
        }
        onCancel={blocking}
        onConfirm={onConfirm || process}
        confirmValue={confirmValue}
      >
        확인 버튼 클릭 시 변경 내용을 저장하지 않고 이동합니다. 변경내용 저장을
        원하실 경우, 취소 후 저장 버튼을 클릭해 주세요.
      </Modal.Body>
    </Modal.Root>
  );
};

export default BeforeUnloadModal;
